import { connect } from "react-redux";
import MyAccountLinks from "./MyAccountLinks";
import { getIsReconsentRequired, isLoggedIn } from "../../state/modules/user";
import {
  getCountryCode,
  getDefaultLanguage,
  getDefaultStoreUrl,
  getKeyStoreDataversion,
  getStoreCode
} from "../../state/modules/regionalStore";
import { isFeatureActive } from "../../state/modules/features";

function mapStateToProps(state) {
  return {
    countryCode: getCountryCode(state),
    defaultStoreUrl: getDefaultStoreUrl(state),
    eventIconToggle: isFeatureActive(state, "web-event-icon"),
    isLoggedIn: isLoggedIn(state),
    isReconsentRequired: getIsReconsentRequired(state),
    keyStoreDataversion: getKeyStoreDataversion(state),
    lang: getDefaultLanguage(state),
    storeCode: getStoreCode(state)
  };
}

export default connect(mapStateToProps)(MyAccountLinks);



// WEBPACK FOOTER //
// ./template/components/MyAccountLinks/index.js